import React, { useState } from 'react'
import PageHead from '../components/PageHead'
import HeaderOne from '../components/ShopCustomisation/HeaderOne/HeaderOne'
import Banner from '../components/ShopCustomisation/Banner/Banner'
import HotSale from '../components/ShopCustomisation/HotSales/HotSale'
import Faq from '../components/ShopCustomisation/Faq/Faq'
import HotUpdate from '../components/ShopCustomisation/HotUpdate/HotUpdate'
import Seo from '../components/ShopCustomisation/SEO/Seo'
import About from '../components/ShopCustomisation/AboutUS/About'
import TermAndCondition from '../components/ShopCustomisation/TermsContion/TermAndCondition'
import Privacy from '../components/ShopCustomisation/TermsContion/Privacy'
import SpecialOffer from '../components/ShopCustomisation/SpecialOffer/SpecialOffer'

function StoreCustomisation() {

    // Tabs
    const [tab, setTab] = useState(1)
    const pages = ["Home Page", "FAQs", "Seo Settings", "Term & Condition", "Privacy Policy"]


    return (
        <div className='w-full relative'>
            <PageHead title={"Store Customisation"} />

            {/* Tabs */}
            <div className="flex mt-7">
                {pages.map((page, i) => (
                    <button
                        key={i}
                        onClick={() => setTab(i + 1)}
                        className={`px-3 py-2 text-sm ${tab === i + 1 ? 'bg-primary text-white' : 'bg-gray-200'}`}
                    >
                        {page}
                    </button>
                ))}
            </div>



            {/* Containers */}
            {tab === 1 && (
                <div className="mt-5 space-y-9">
                    <HotUpdate />
                    <HeaderOne />
                    <Banner />
                    <HotSale />
                    <SpecialOffer />
                </div>
            )}

            {tab === 2 && (
                <div className="mt-5">
                    <Faq />
                </div>
            )}

            {tab === 3 && (
                <div className="mt-5">
                    <Seo />
                </div>
            )}

            {tab === 4 && (
                <div className="mt-5">
                    <TermAndCondition />
                </div>
            )}

            {tab === 5 && (
                <div className="mt-5">
                    <Privacy />
                </div>
            )}
        </div>
    )
}

export default StoreCustomisation